import { Page } from "../interfaces/Page";

export const PAGESPUB: Array<Page>  = [
    {
        slug: 'example',
        title: 'Título de ejemplo seg publica',
        subtitle: 'lorem Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat doloribus, impedit officia doloremque reiciendis illo quis eveniet eum labore, magnam quo. Doloribus facilis odit nesciunt officiis suscipit voluptatum earum? Aperiam!Excepturi, sequi tempora? Modi quos maxime reiciendis odio sit aliquam saepe neque praesentium ullam nulla quis natus, laudantium sunt quaera',
        bannerImg: 'assets/sectors/public-security-1.jpg',
        bannerImgMobile: 'assets/sectors/public-security-1-mobile.jpg',

        rows: {
            titles: [
                'Puntos débiles', 'columna centro', 'Ventajas',
            ],
            text: [
                ['El apoyo aéreo tradicional, como los helicópteros, es limitado y caro, y hace que los equipos de tierra tengan que cubrir grandes áreas.', 'texto central', 'Despliega apoyo aéreo de forma rápida y rentable para ayudar a los equipos tácticos y de vigilancia.'],
                ['El apoyo aéreo tradicional, como los helicópteros, es limitado y caro, y hace que los equipos de tierra tengan que cubrir grandes áreas.', 'texto central', 'Despliega apoyo aéreo de forma rápida y rentable para ayudar a los equipos tácticos y de vigilancia.'],
                ['El apoyo aéreo tradicional, como los helicópteros, es limitado y caro, y hace que los equipos de tierra tengan que cubrir grandes áreas.', 'texto central', 'Despliega apoyo aéreo de forma rápida y rentable para ayudar a los equipos tácticos y de vigilancia.'],
            ]
        },

        solution: {
            title: 'Ejemplo titulo muy pero que muy largo',
            text: 'lorem Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat doloribus, impedit officia doloremque reiciendis illo quis eveniet eum labore, magnam quo. Doloribus facilis odit nesciunt officiis suscipit voluptatum earum? Aperiam!Excepturi, sequi tempora? Modi quos maxime reiciendis odio sit aliquam saepe neque praesentium ullam nulla quis natus, laudantium sunt quaerat dolorum adipisci soluta reprehenderit! Deleniti placeat consequuntur iusto maxime nobis!',
            textList: [
                'elemento 1',
                'elemento aa',
                'elemento 44',
                'elemento easda',
            ],
            img: 'assets/sectors/solution-cards/solution-card-1.jpg',
            imgMobile: 'assets/sectors/solution-cards/solution-card-1-mobile.jpg',
            link: 'https://google.com'
        }


    }
]